import { useEffect, useState } from 'react'
import { useLocation, Outlet, Navigate, useNavigate } from 'react-router-dom';
import useAuth from '../hook/useAuth';
import { jwtDecode } from "jwt-decode";
import Cookies from 'js-cookie';
import { isTokenExpired } from '../utils/isTokenExpired';

type Props = {
    allowedRoles: string[];
}

const RequriedAuth = ({ allowedRoles }: Props) => {
    const { setAuth }: any = useAuth();
    const [authIsFound, setAuthIsFound] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();
    const expires = Cookies.get("expires-my-cdir");
    const groupId = Cookies.get("groupId-my-cdir") || "";
    const role = Cookies.get("role-my-cdir") || "";
    const token = Cookies.get("token-my-cdir");
    const plan = Cookies.get("plan-my-cdir") || "";

    useEffect(() => {
        if (token && !authIsFound) {
            const jsonData: any = jwtDecode(token);
            const id = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"];
            const roles = jsonData["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
            const user = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
            const givenname = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"];
            const emailAddress = jsonData["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            setAuth({ id, userName: user, givenname, emailAddress, roles, token, groupId, planName: plan });
            setAuthIsFound(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (token && isTokenExpired(expires)) {
            const redirectPath = role?.toLowerCase() === "superadmin" ? "/superadmin-sign-in" : "/sign-in";

            setAuth(null);
            Cookies.remove("role-my-cdir");
            Cookies.remove("token-my-cdir");
            Cookies.remove("groupId-my-cdir");
            Cookies.remove("userId-my-cdir");
            Cookies.remove("isAdmin-my-cdir");
            Cookies.remove("plan-my-cdir");
            Cookies.remove("expires-my-cdir");

            navigate(redirectPath, {
                state: { from: location },
                replace: true,
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, expires, role, navigate, location, setAuth]);

    return (
        token ?
            allowedRoles.some((allowedRole: string) => allowedRole.toLowerCase().includes(role?.toString()?.toLowerCase())) ?
                (role?.toString()?.toLowerCase() === "admin" && (location?.pathname.includes("superadmin") || location?.pathname.includes("user") || location?.pathname.includes("credit-cards") || location?.pathname.includes("faq") || location?.pathname.includes("payment-gateway") || location?.pathname.includes("addChurch") || location?.pathname.includes("deleteChurch"))) ?
                    <Navigate
                        to="/un-authorized"
                        state={{ from: location }}
                        replace
                    />
                    :
                    <Outlet />
                :
                <Navigate to="/not-found" replace={true} />
            :
            <Navigate to={role?.toLowerCase() === "superadmin" ? "/superadmin-sign-in" : "/sign-in"} state={{ from: location }} replace />
    );
}

export default RequriedAuth;